import { EmptyCart } from './empty_cart';

export default EmptyCart;
